import React from 'react';
import CaremapprModal from '../../../../components/Modal/CaremapprModal/CaremapprModal';
import { ExternalProvider } from '../../../../../lib';
import { useExternalAuth } from '../../context/ExternalAuthProvider';

interface BaseOAuthModalProps {
  provider: ExternalProvider;
  header?: React.ReactNode;
  children?: React.ReactNode;
}

const BaseOAuthModal = ({
  provider,
  header,
  children,
}: BaseOAuthModalProps) => {
  const { open, onClose } = useExternalAuth();

  return (
    <CaremapprModal
      showCloseButton
      id={`${provider}-modal`}
      show={open}
      onHide={onClose}
      header={header ?? <span>Connect to {provider}</span>}
      body={<div>{children}</div>}
    />
  );
};

export default BaseOAuthModal;
